/* Product page: colour swatches drive photos, price, URL (?variant=) and the add-to-cart state.
   Runs on DOMContentLoaded so theme.js (window.KCTheme) is ready whatever the script order. */
document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector("[data-product]");
  const dataEl = document.querySelector("[data-product-json]");
  if (!root || !dataEl) return;
  const P = JSON.parse(dataEl.textContent);
  const T = () => window.KCTheme;
  const q = (sel) => document.querySelector(sel);
  const dh = (c) => T().dh(c);

  const initial = new URLSearchParams(location.search).get("variant");
  const v0 = P.variants.find((v) => String(v.id) === initial) || P.variants.find((v) => v.available) || P.variants[0];
  const state = { c: v0.c, s: P.hasSize ? (initial ? v0.s : null) : null };

  const colourVariants = (c) => P.variants.filter((v) => v.c === c);
  const current = () => P.variants.find((v) => v.c === state.c && (!P.hasSize || v.s === state.s));
  const colourMedia = (c) => P.media.filter((m) => !P.hasColour || (m.alt || "").toLowerCase().includes(` ${c.toLowerCase()},`));
  const canBuy = (v) => v.available && !v.preorder;

  function renderGallery() {
    const g = q("[data-gallery]");
    const media = colourMedia(state.c);
    // 2-column grid on desktop; with an odd count the first photo spans the full width.
    const span = (i) => (i === 0 && media.length % 2 === 1 ? 6 : 3);
    g.innerHTML = media.map((m, i) => `<figure data-span="${span(i)}"><img src="${T().esc(m.src)}" srcset="${[600, 900, 1300].map((w) => `${T().esc(T().sized(m.src, w))} ${w}w`).join(", ")}" sizes="(min-width: 1000px) ${span(i) === 6 ? "64vw" : "32vw"}, 100vw" alt="${T().esc(m.alt)}"${i ? ' loading="lazy"' : ""}></figure>`).join("");
    g.scrollLeft = 0;
    q("[data-gallery-count]").innerHTML = media.length > 1 ? media.map((_, i) => `<i class="${i ? "" : "is-on"}"></i>`).join("") : "";
    // long layout: thumbnails next to the gallery (desktop)
    const th = q("[data-gallery-thumbs]");
    if (th) th.innerHTML = media.length > 1 ? media.map((m, i) => `<button type="button" data-thumb="${i}" aria-label="Photo ${i + 1} sur ${media.length}"${i ? "" : ' aria-current="true"'}><img src="${T().esc(T().sized(m.src, 200))}" alt="" loading="lazy" width="84" height="105"></button>`).join("") : "";
  }

  function priceInfo() {
    const v = current();
    if (v) return { main: dh(v.price), note: "" };
    const vs = colourVariants(state.c);
    const groups = new Map();
    vs.forEach((x) => groups.set(x.price, [...(groups.get(x.price) || []), x.s]));
    const sorted = [...groups.entries()].sort((a, b) => a[0] - b[0]);
    return { main: dh(sorted[0][0]), note: sorted.slice(1).map(([p, labels]) => `${labels.join(" et ")} : ${dh(p)}`).join(", ") };
  }

  function action() {
    const v = current();
    if (!v) return { kind: "pick", label: "Ajouter au panier", short: "Ajouter", note: "" };
    if (canBuy(v)) return { kind: "add", label: `Ajouter au panier, ${dh(v.price)}`, short: "Ajouter", note: "" };
    if (v.preorder) return { kind: "add", label: `Précommander, ${dh(v.price)}`, short: "Précommander", note: "Confectionnée pour vous en 6 jours environ, puis expédiée. Confirmation par e-mail ou WhatsApp." };
    const outNote = `${P.hasSize ? `Taille ${v.s} épuisée` : "Épuisé"} en ${v.c}.`;
    if (!window.KCT.whatsapp) return { kind: "out", label: "Épuisé", short: "Épuisé", note: `${outNote} Choisis une autre taille ou une autre couleur.` };
    return { kind: "notify", label: "Me prévenir sur WhatsApp", short: "Me prévenir", note: `${outNote} Nous t'écrivons dès son retour.` };
  }

  function render() {
    const v = current();
    const p = priceInfo(); const a = action();
    q("[data-price]").textContent = p.main;
    q("[data-price-note]").textContent = p.note;
    q("[data-atc]").textContent = a.label;
    q("[data-note]").textContent = a.note;
    q("[data-sticky-atc]").textContent = a.short;
    q("[data-sticky-title]").textContent = P.hasColour ? `${P.short}, ${state.c}` : P.short;
    q("[data-sticky-price]").textContent = state.s ? `Taille ${state.s}, ${p.main}` : p.main;
    const name = q("[data-colour-name]"); if (name) name.textContent = state.c;
    const ask = q("[data-ask]");
    if (ask) ask.href = T().waLink(`Bonjour, je souhaite commander ${P.title}${P.hasColour ? ` en ${state.c}` : ""}${state.s ? `, taille ${state.s}` : ""}.`);
    q("[data-variant-input]").value = (v || colourVariants(state.c)[0]).id;

    document.querySelectorAll("[data-sw]").forEach((b) => {
      const vs = colourVariants(b.dataset.sw);
      const out = !vs.some((x) => x.available);
      b.setAttribute("aria-pressed", String(b.dataset.sw === state.c));
      b.dataset.out = String(out);
      b.setAttribute("aria-label", `${b.dataset.sw}${out ? ", épuisé" : ""}`);
    });
    document.querySelectorAll("[data-size]").forEach((b) => {
      const x = P.variants.find((y) => y.c === state.c && y.s === b.dataset.size);
      b.hidden = !x;
      b.dataset.out = String(!x || !x.available);
      b.setAttribute("aria-pressed", String(b.dataset.size === state.s));
      b.setAttribute("aria-label", `Taille ${b.dataset.size}${x && x.available ? "" : ", épuisée"}`);
    });
    document.querySelectorAll("[data-tile]").forEach((t) => t.setAttribute("aria-current", String(t.dataset.tile === state.c)));
    const target = v || colourVariants(state.c)[0];
    history.replaceState(null, "", `${P.url}?variant=${target.id}`);
  }

  function setColour(c) {
    state.c = c;
    if (state.s && !colourVariants(c).some((v) => v.s === state.s)) state.s = null;
    q("[data-msg]").textContent = "";
    renderGallery();
    render();
  }

  async function submit(e) {
    e?.preventDefault();
    const a = action(); const v = current();
    if (a.kind === "pick") {
      q("[data-msg]").textContent = "Choisis ta taille.";
      q("[data-sizes-block]")?.scrollIntoView({ block: "center", behavior: "smooth" });
      q("[data-size]:not([hidden])")?.focus();
      return;
    }
    if (a.kind === "out") return;
    if (a.kind === "notify") {
      window.open(T().waLink(`Bonjour, prévenez-moi quand ${P.title} ${v.c}${v.s ? ` taille ${v.s}` : ""} sera de retour.`), "_blank", "noopener");
      return;
    }
    const btn = q("[data-atc]");
    btn.setAttribute("aria-disabled", "true");
    try { await T().addToCart(v.id); q("[data-msg]").textContent = ""; }
    catch (err) { q("[data-msg]").textContent = err.message; }
    finally { btn.removeAttribute("aria-disabled"); }
  }

  document.addEventListener("click", (e) => {
    const sw = e.target.closest("[data-sw]"); const sz = e.target.closest("[data-size]"); const tile = e.target.closest("[data-tile]");
    const thumb = e.target.closest("[data-thumb]");
    if (thumb) { const gal = q("[data-gallery]"); gal.scrollTo({ left: Number(thumb.dataset.thumb) * gal.clientWidth, behavior: "smooth" }); return; }
    if (sw) setColour(sw.dataset.sw);
    else if (sz) { state.s = sz.dataset.size; q("[data-msg]").textContent = ""; render(); sz.focus(); }
    else if (tile) { e.preventDefault(); setColour(tile.dataset.tile); window.scrollTo({ top: 0, behavior: "smooth" }); }
  });
  q("[data-add-form]").addEventListener("submit", submit);
  q("[data-sticky-atc]").addEventListener("click", submit);

  const g = q("[data-gallery]");
  g.addEventListener("scroll", () => {
    const i = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
    document.querySelectorAll("[data-gallery-count] i").forEach((d, k) => d.classList.toggle("is-on", k === i));
    document.querySelectorAll("[data-thumb]").forEach((b, k) => { if (k === i) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current"); });
  }, { passive: true });

  // long layout: tabs (Détails / Taille / Livraison...), arrow keys move between tabs
  document.querySelectorAll("[data-tabs]").forEach((box) => {
    const tabs = [...box.querySelectorAll('[role="tab"]')];
    const select = (t) => tabs.forEach((x) => {
      const on = x === t;
      x.setAttribute("aria-selected", String(on));
      x.tabIndex = on ? 0 : -1;
      document.getElementById(x.getAttribute("aria-controls")).hidden = !on;
    });
    box.addEventListener("click", (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t); });
    box.addEventListener("keydown", (e) => {
      const i = tabs.indexOf(document.activeElement);
      const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
      if (i < 0 || !step) return;
      e.preventDefault();
      const next = tabs[(i + step + tabs.length) % tabs.length];
      next.focus(); select(next);
    });
  });

  const bar = q("[data-sticky]");
  new IntersectionObserver(([en]) => {
    const show = !en.isIntersecting && en.boundingClientRect.top < 0;
    bar.classList.toggle("is-on", show);
    bar.setAttribute("aria-hidden", String(!show));
    q("[data-sticky-atc]").tabIndex = show ? 0 : -1;
  }).observe(q("[data-atc]"));

  renderGallery();
  render();
});
